import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import type { EditAsideSimpleDropDown } from '@nodeTypeConfig/configTypes';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import * as DOCUMENT_ACTIONS from '../../../../reduxLoop/actions/documentActions';

import { useInitialValue } from '../../../hooks/UseInitialValue';

import { useEditHref } from '../../../hooks/UseEditHref';

const AsideSimpleDropDown: React.FC<{ config: EditAsideSimpleDropDown; readonly: boolean }> = ({
  config,
  readonly,
}) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const { options } = config.options;

  const currentValue = useInitialValue(config.property);

  const defaultValue = options.find((t) => currentValue === t.key);

  const onChange = (selection: EditAsideSimpleDropDown['options']['options'][0]) => {
    dispatch(
      DOCUMENT_ACTIONS.patchNodeAction(
        getResourceKey(editHref),
        set({}, config.property, selection?.key || undefined),
      ),
    );
  };

  return (
    <>
      <label className="control-label">{config.label}</label>
      <KovResourcePicker
        localData={options}
        display="label"
        defaultValue={defaultValue}
        clearable={config.options.clearable}
        disabled={readonly}
        disableSearch={true}
        style={{ option: (provided) => ({ ...provided, cursor: 'pointer' }) }}
        onChange={onChange}
      />
    </>
  );
};

AsideSimpleDropDown.displayName = 'AsideSimpleDropDown';

AsideSimpleDropDown.propTypes = {
  config: any,
  readonly: any,
};

export default AsideSimpleDropDown;
